/**
 * Application configuration
 * Centralized config management using environment variables
 */

const config = {
  // API URLs - All requests go through chat_backend
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8001',
  // Note: RAG API is now accessed via backend proxy at /api/v1/rag/*
  // No need for direct RAG URL anymore
  
  // Language settings
  defaultLanguage: process.env.REACT_APP_DEFAULT_LANGUAGE || 'vi',
  
  // App info
  appName: 'Coaris Chat',
  version: '1.0.0',
};

export default config;
